<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRoute } from 'vue-router';
import AppSidebar from '@/components/AppSidebar.vue';
import { useAuthenticatedBootstrap } from '@/composables/useAuthenticatedBootstrap';
import { useAuthStore } from '@/stores/auth';

const route = useRoute();
const authStore = useAuthStore();

useAuthenticatedBootstrap({ checkChangelogs: true });

const collapsed = ref(false);

// Auto-collapse sidebar based on route meta
watch(
  () => route.meta.collapseSidebar,
  shouldCollapse => {
    collapsed.value = shouldCollapse === true;
  },
  { immediate: true }
);
</script>

<template>
  <!-- `has-sider` only means "lay the children out in a row" — naive does not
       require an n-layout-sider in that slot, so GaiaSidebar (a flex:none aside
       that owns its own width, border and collapse toggle) drops straight in. -->
  <n-layout has-sider position="absolute">
    <app-sidebar v-if="authStore.isAuthenticated" v-model:collapsed="collapsed" />

    <n-layout-content content-style="padding: 0;">
      <router-view />
    </n-layout-content>
  </n-layout>
</template>

<style scoped>
:deep(.n-layout-content) {
  background-color: var(--body-color);
}
</style>
